// @ts-nocheck
import $ from "jquery";
import React from "react";
import { decorators as baseDecorators } from "./Treebeard";
import { Draggable } from "react-drag-and-drop";
import PubSub from "pubsub-js";
import { toast } from "react-toastify";
import { treeElementTypes } from "../../constants";
import { eventNames } from "../../constants/eventNames";
import { AuthService } from "../../services/auth.service";
import BugIcon from "../../assets/images/bug_icon.svg";
import EpicIcon from "../../assets/images/epic_icon.svg";
import StoryIcon from "../../assets/images/story_icon.svg";
import TaskIcon from "../../assets/images/task_icon.svg";
import classes from "./tooltip.module.css";

const issueType = {
  Bug: BugIcon,
  Epic: EpicIcon,
  Story: StoryIcon,
  Task: TaskIcon
};

const hasTargetDependencies = (node, type) => {
  if (!node.dependencies || !node.dependencies.length) return false;
  const targetDependence = node.dependencies.find(dependence => dependence.elementType === type);
  return !!targetDependence;
};

const hasTargetUserVariable = (node, type) => {
  return node && node.elementType === type && node.isGlobal === true;
};

const hasRuntimeVariable = (node, type) => {
  return node && node.name === "Runtime Variable";
};

const hasTargetCsv = (node, type) => {
  if (!node.dependencies || !node.dependencies.length) return false;
  const targetDependence = node.dependencies.find(dependence => dependence.elementType === type);
  if (!!targetDependence) {
    return !!node.dependencies.find(dependence => dependence.hasContent === true);
  }
  return false;
};

// Custom Container component
const CustomContainer = ({ style, decorators, terminal, onClick, node }) => {
  let styles;
  if (node.active) {
    styles = Object.assign({}, { ...style.customContainer.link }, { ...style.customContainer.activeLink });
  } else {
    styles = style.customContainer.link;
  }
  if (!terminal) {
    styles = Object.assign({}, styles, style.customContainer.node);
  } else {
    styles = Object.assign({}, styles);
  }

  const ToggleComponent = decorators.Toggle;
  const HeaderComponent = decorators.Header;

  return (
    <div className={"tree-node " + (node.active ? "active" : "") + (node.toggled ? " toggled" : "")} onClick={onClick} style={styles}>
      {!terminal && <ToggleComponent style={style.toggle} node={node} />}
      <HeaderComponent node={node} style={style.header} />
    </div>
  );
};

// Custom Toggle component
const Toggle = ({ style }) => {
  return (
    <div className="node-arrow-icon1" style={style.base}>
      <i className="fa fa-angle-right"></i>
    </div>
  );
};

// Customising The Header Decorator To Include Icons
const Header = ({ style, node }) => {
  const [displayTooltip, setDispleyTooltip] = React.useState(false);
  const [tooltipText, setTooltipText] = React.useState("");
  const nodeIcons = {
    file: {
      DATASOURCE: "fas fa-file-csv",
      FLOW: "fas fa-code-branch",
      VIRTUALIZATION: "fas fa-cubes",
      SCRIPT: "fas fa-file-code",
      COMPONENT: "fas fa-puzzle-piece",
      USERVARIABLE: "fas fa-user-tag",
      CONNECTION: "fas fa-database",
      API: "fas fa-plug",
      GRAPHQL: "fas fa-share-alt",
      component: "fas fa-cog",
      default: "fas fa-file-alt",
      GLOBALVARIABLE: "fas fa-globe",
      REPORT: "fas fa-chart-bar",
      CRAWLER: "fas fa-spider"
    },
    folder: {
      connection: "fas fa-database",
      GROUP: "fas fa-layer-group",
      FLOW: "fas fa-sitemap",
      SCRIPT: "fas fa-file-code",
      COMPONENT: "fas fa-puzzle-piece",
      USERVARIABLE: "fas fa-users-cog",
      datasource: "fas fa-table",
      flow: "fas fa-code-branch",
      virtualization: "fas fa-cubes",
      script: "fas fa-file-code",
      uservariable: "fas fa-users-cog",
      component: "fas fa-puzzle-piece",
      api: "fas fa-plug",
      graphql: "fas fa-share-alt",
      crawler: "fas fa-spider",
      default: "fas fa-folder",
      report: "fas fa-chart-line",
      PROJECT: "fas fa-folder-open"
    },
    // Map group names to icons for GROUP type nodes
    groupByName: {
      "Components": "fas fa-puzzle-piece",
      "Variables": "fas fa-sliders-h",
      "Scripts": "fas fa-file-code",
      "Flows": "fas fa-code-branch",
      "Apis": "fas fa-plug",
      "Database": "fas fa-database",
      "Connections": "fas fa-database",
      "Reports": "fas fa-chart-line",
      "Results Map": "fas fa-chart-line",
      "Datasources": "fas fa-table",
      "Virtualization": "fas fa-cubes",
      "GraphQLs": "fas fa-share-alt",
      "Graphqls": "fas fa-share-alt",
      "Crawler": "fas fa-spider",
      "Crawlers": "fas fa-spider"
    }
  };

  // Get icon class based on node type
  const getIconClass = () => {
    // If it's a GROUP element type, try to match by name first
    if (node.elementType === "GROUP" && node.name && nodeIcons.groupByName[node.name]) {
      return nodeIcons.groupByName[node.name];
    }
    // Otherwise use the standard lookup
    if (node.children) {
      return nodeIcons.folder[node.elementType] || nodeIcons.folder[node.contentType] || nodeIcons.folder.default;
    }
    return nodeIcons.file[node.elementType] || nodeIcons.file.default;
  };

  const isComponentWithFile = hasTargetDependencies(node, treeElementTypes.file);
  const isComponentWithDatasource = hasTargetDependencies(node, treeElementTypes.dataSource);
  const isComponentWithScript = hasTargetDependencies(node, treeElementTypes.script);
  const isComponentWithConnection = hasTargetDependencies(node, treeElementTypes.connection);
  const isComponentWithCsv = hasTargetCsv(node, treeElementTypes.dataSource);
  const isRuntimeVariable = hasRuntimeVariable(node, treeElementTypes.dataSource);
  const isComponentUserVariable = hasTargetUserVariable(node, treeElementTypes.projectuser);

  const iconClass = getIconClass();
  function handleDoubleClick(e) {
    e.stopPropagation();
  }

  let activeTost = {};
  const editName = (node, e) => {
    e.preventDefault();
    e.stopPropagation();
    let id = node.id;
    if (node.params && node.params.userId && node.params.userId !== AuthService.user?.id) {
      const tostId = `toastId${id}`;
      if (toast.isActive(activeTost[tostId])) return;
      return (activeTost[tostId] = toast.error("You can't rename projects that you didn't create 1."));
    }

    const block = $(e.target).closest(".content-line");

    const textBlock = block.find(`#text-id-${id}`);
    if (block && textBlock) {
      let input = e.target.parentNode.parentNode.parentNode.querySelector(".text-ellipsis");
      let url = input.getAttribute("data-parent-type");
      if (url === "apis") url = "api";
      PubSub.publish(eventNames.treeNodeName, { id, name: textBlock.text(), url, isGlobal: node.isGlobal });
      PubSub.unsubscribe(eventNames.treeNodeNameUpdated);
      PubSub.subscribe(eventNames.treeNodeNameUpdated, (msg, data) => {
        setTimeout(() => {
          input.innerText = data.name;
          node.name = data.name;
          node.isGlobal = data.isGlobal;
          PubSub.publish(eventNames.editeTreeName);
        }, 200);
        PubSub.unsubscribe(eventNames.treeNodeNameUpdated);
      });
    }
  };

  const gitLog = (node, e) => {
    e.preventDefault();
    e.stopPropagation();
    let id = node.id;
    const block = $(e.target).closest(".content-line");
    const textBlock = block.find(`#text-id-${id}`);
    if (block && textBlock) {
      let input = e.target.parentNode.parentNode.parentNode.querySelector(".text-ellipsis");
      let url = input.getAttribute("data-parent-type");
      if (url === "apis") url = "api";
      PubSub.publish(eventNames.treeGitLog, { id, name: textBlock.text(), url, isGlobal: node.isGlobal });
      PubSub.unsubscribe(eventNames.treeGitLogUpdated);
      PubSub.subscribe(eventNames.treeGitLogUpdated, (msg, data) => {
        setTimeout(() => {
          input.innerText = data.name;
          node.name = data.name;
          node.isGlobal = data.isGlobal;
          PubSub.publish(eventNames.gitLogEvent);
        }, 200);
        PubSub.unsubscribe(eventNames.treeGitLogUpdated);
      });
    }
  };

  const gitFlow = (node, e) => {
    e.preventDefault();
    e.stopPropagation();
    let id = node.id;
    const block = $(e.target).closest(".content-line");
    const textBlock = block.find(`#text-id-${id}`);
    if (block && textBlock) {
      let input = e.target.parentNode.parentNode.parentNode.querySelector(".text-ellipsis");
      let url = input.getAttribute("data-parent-type");
      if (url === "apis") url = "api";
      PubSub.publish(eventNames.treeGitFlow, { id, name: textBlock.text(), url, isGlobal: node.isGlobal });
      PubSub.unsubscribe(eventNames.treeGitFlowUpdated);
      PubSub.subscribe(eventNames.treeGitFlowUpdated, (msg, data) => {
        setTimeout(() => {
          input.innerText = data.name;
          node.name = data.name;
          node.isGlobal = data.isGlobal;
          PubSub.publish(eventNames.gitFlowEvent);
        }, 200);
        PubSub.unsubscribe(eventNames.treeGitFlowUpdated);
      });
    }
  };

  const virtualization = (node, e) => {
    e.preventDefault();
    e.stopPropagation();
    let id = node.id;
    if (node.params && node.params.userId && node.params.userId !== AuthService.user?.id) {
      const tostId = `toastId${id}`;
      if (toast.isActive(activeTost[tostId])) return;
      return (activeTost[tostId] = toast.error("You can't rename projects that you didn't create 4."));
    }

    const block = $(e.target).closest(".content-line");

    const textBlock = block.find(`#text-id-${id}`);
    if (block && textBlock) {
      let input = e.target.parentNode.parentNode.parentNode.querySelector(".text-ellipsis");
      let url = input.getAttribute("data-parent-type");
      if (url === "apis") url = "api";
      PubSub.publish(eventNames.treeVirtualization, {
        id,
        projectId: node.projectID,
        name: textBlock.text(),
        url,
        isGlobal: node.isGlobal
      });
      PubSub.unsubscribe(eventNames.treeVirtualizationUpdated);
      PubSub.subscribe(eventNames.treeVirtualizationUpdated, (msg, data) => {
        setTimeout(() => {
          input.innerText = data.name;
          node.name = data.name;
          node.isGlobal = data.isGlobal;
          PubSub.publish(eventNames.virtualizationEvent);
        }, 200);
        PubSub.unsubscribe(eventNames.treeVirtualizationUpdated);
      });
    }
  };

  const onChangeFileName = e => {
    const target = e.target;
    const value = target.textContent.trim();
    value.length > 50 ? (target.innerText = value.slice(0, 50)) : (target.innerText = value);

    const range = document.createRange();
    range.selectNodeContents(target);
    range.collapse(false);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  };

  const dragData = {
    elementType: node.elementType,
    id: node.id,
    name: node.name,
    projectID: node.projectID,
    groupID: node.groupID,
    dependencies: node.dependencies
  };

  // DEBUG: Log when drag starts via native HTML5 events (to supplement react-drag-and-drop)
  const handleNativeDragStart = (e: any) => {
    console.log('[decorators.tsx] 🎯 Native drag start for:', node.name);
    console.log('[decorators.tsx] 🎯 Element type:', node.elementType);
    console.log('[decorators.tsx] 🎯 Drag data:', JSON.stringify(dragData));
    // Ensure data is set for native HTML5 drag and drop
    if (e.dataTransfer) {
      e.dataTransfer.setData('application/json', JSON.stringify(dragData));
      e.dataTransfer.setData('text/plain', JSON.stringify(dragData));
      // Also set type-specific data for react-drag-and-drop compatibility
      e.dataTransfer.setData(node.elementType.toLowerCase(), JSON.stringify(dragData));
      e.dataTransfer.effectAllowed = 'move';
      console.log('[decorators.tsx] 🎯 Set dataTransfer data types:', e.dataTransfer.types);
    }
  };

  const checkHelpTree = elementType => {
    return (
      elementType === "file" ||
      elementType === "directory" ||
      elementType === "root" ||
      elementType === "board" ||
      elementType === "issuetype" ||
      elementType === "sprint" ||
      elementType === "issue" ||
      elementType === "backlog"
    );
  };

  React.useEffect(() => {
    if (node.params) {
      const params = node.params;
      if (
        AuthService.user?.id === params.userId &&
        params.sharedUsers !== undefined &&
        params.sharedUsers !== null &&
        params.sharedUsers.length > 0
      ) {
        let text = `Assigned to `;
        let initText = `Assigned to `;
        for (let i in params.sharedUsers) {
          if (
            params.sharedUsers[i] &&
            params.sharedUsers[i].name !== undefined &&
            params.sharedUsers[i].name !== null
          ) {
            text += `@${params.sharedUsers[i].name}${i === params.sharedUsers.length - 1 ? "" : ", "}`;
          }
        }
        if (text.length > initText.length) {
          text = text.substring(0, text.length - 2);
        }
        setTooltipText(text);
      } else if (AuthService.user?.id !== params.userId && params.owner && params.owner.length > 0) {
        setTooltipText(`Assigned by @${params.owner[0].name}`);
      }
    }
  }, [tooltipText]);

  const handleShowTooltip = () => {
    if (node.elementType === "PROJECT") {
      if (
        AuthService.user?.id === node.params.userId &&
        node.params.sharedUsers !== undefined &&
        node.params.sharedUsers !== null &&
        node.params.sharedUsers.length === 0
      )
        setDispleyTooltip(false);
      else setDispleyTooltip(true);
    }
  };

  const handleHideTooltip = () => {
    node.elementType === "PROJECT" && setDispleyTooltip(false);
  };

  if (!node || !node.elementType) return null;

  return checkHelpTree(node.elementType.toLowerCase()) ? (
    <div className={"content-line-wrap"} style={style.base}>
      {
        <div style={style.title} className="content-line" datatype={node.name}>
          <span style={style.titleIcon} className="tree-icons">
            {node.elementType === "issueType" || node.directoryName === "issueType" ? (
              <img
                style={{ height: 16, width: 16 }}
                src={issueType[node.elementType === "issueType" ? node.name : node.parentIssueType]}
                alt="issue-type"
              />
            ) : (
              /*<i className={"icon " + iconClass} />*/
              <i style={{ height: 16, width: 16 }} className={iconClass} alt="" />
            )}
          </span>
          <span
            className="text-ellipsis"
            style={style.titleText}
            onDoubleClick={handleDoubleClick}
            id={`text-id-${node.id}`}
          >
            {node.name}
          </span>
        </div>
      }
    </div>
  ) : (
    <Draggable
      className={"content-line-wrap"}
      style={style.base}
      type={node.elementType.toLowerCase()}
      data={JSON.stringify(dragData)}
      onDragStart={handleNativeDragStart}
    >
      {
        <React.Fragment>
          <div
            style={style.title}
            className="content-line"
            datatype={node.name}
            onMouseEnter={() => handleShowTooltip()}
            onMouseLeave={() => handleHideTooltip()}
            onDragStart={handleNativeDragStart}
          >
            <span
              style={style.titleIcon}
              className={
                isComponentWithDatasource || isComponentWithScript || isComponentWithFile
                  ? "tree-icons multi"
                  : "tree-icons"
              }
            >
              {isComponentWithCsv && <i title="CSV file" className={"icon " + nodeIcons.file.DATASOURCE} />}
              {isComponentWithScript && <i title="JS file" className={"icon " + nodeIcons.file.SCRIPT} />}
              {isComponentWithConnection && <i title="DB Connection" className={"icon " + nodeIcons.file.CONNECTION} />}
              {isComponentUserVariable && (
                <i title="Global Variable" className={"mr-1 icon " + nodeIcons.file.GLOBALVARIABLE} />
              )}
              <i className={"icon " + iconClass} />
              {/*<img style={{ height: 16, width: 16 }} src={iconClass} />*/}
            </span>
            {tooltipText !== "" && (
              <span style={style.titleIcon}>
                {/*<img src={user} />*/}
                <i className="ico ico-contact" />
              </span>
            )}
            <span
              className="text-ellipsis"
              style={
                node.isEnable && node.name !== "Reporting" && node.elementType !== "REPORT"
                  ? node.elementType === "USERVARIABLE"
                    ? style.activeTitleText
                    : style.titleText
                  : style.titleText
              }
              onDoubleClick={handleDoubleClick}
              id={`text-id-${node.id}`}
              contentEditable={false}
              onInput={e => onChangeFileName(e)}
              data-parent-type={`${node.elementType.toLowerCase()}s`}
            >
              {node.name === "Connections" ? "Database" : node.name === "Reports" ? "Results Map" : node.name}
            </span>
            {!isRuntimeVariable && (
              <ul title={"Assign Users"} className="actions-icon" data-id={node.id}>
                {node.params
                  ? AuthService.user?.id === node.params.userId && (
                      <li
                        className="ico-contact-block"
                        style={{
                          backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                        }}
                      >
                        <button
                          className="ico ico-contact"
                          data-action={"contact"}
                          onClick={e => e.stopPropagation()}
                        />
                      </li>
                      /*<li className="ico-contact-block">
                        <button className="ico w-100" data-action={"contact"} onClick={e => e.stopPropagation()}>
                          <img style={{ height: 17, width: 17 }} src={userCircle} />
                        </button>
                      </li>*/
                    )
                  : ""}
                {node.elementType === "PROJECT" && node.params &&
                  AuthService.user?.id === node.params.userId && (
                    <>
                      <li
                        title={"Project Settings"}
                        className="ico-edit-block"
                        style={{
                          backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                        }}
                      >
                        <button
                          className="fa fa-cog"
                          data-action={"projectSettings"}
                          onClick={e => e.stopPropagation()}
                        />
                      </li>
                    </>
                  )}
                {node.elementType === "USERVARIABLE" &&
                  !node.isGlobal &&
                  !node.isEnable &&
                  node.name !== "Runtime Variable" && (
                    <li
                      title={"Enable"}
                      className="ico-copy-block"
                      style={{
                        backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                      }}
                    >
                      <button className="fa fa-check" data-action={"enable"} onClick={e => e.stopPropagation()} />
                    </li>
                  )}
                {node.elementType === "USERVARIABLE" &&
                  !node.isGlobal &&
                  node.isEnable === true &&
                  node.name !== "Runtime Variable" && (
                    <li
                      title={"Disable"}
                      className="ico-copy-block"
                      style={{
                        backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                      }}
                    >
                      <button className="fa fa-times" data-action={"disable"} onClick={e => e.stopPropagation()} />
                    </li>
                  )}
                {node.elementType !== "REPORT" && node.name !== "Runtime Variable" && (
                  <li
                    title={"Rename"}
                    className="ico-edit-block"
                    style={{
                      backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                    }}
                  >
                    <button className="ico ico-edit" onClick={e => editName(node, e)} />
                  </li>
                )}
                {node.elementType !== "REPORT" && node.name !== "Runtime Variable" && (
                  <li
                    title={"Delete"}
                    className="ico-remove-block"
                    style={{
                      backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                    }}
                  >
                    <button className="ico ico-remove" data-action={"remove"} onClick={e => e.stopPropagation()} />
                  </li>
                )}
                {/* Git Flow feature hidden - uncomment to re-enable
                {node.elementType === "PROJECT" && (
                  <li
                    title={"Git Flow"}
                    className="ico-flows"
                    style={{
                      backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                    }}
                  >
                    <button className="ico ico-flows" onClick={e => gitFlow(node, e)} />
                  </li>
                )}
                */}
                {node.elementType === "PROJECT" && (
                  <li
                    title={"Git Log"}
                    className="ico-clock"
                    style={{
                      backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                    }}
                  >
                    <button className="ico ico-clock" onClick={e => gitLog(node, e)} />
                  </li>
                )}
                {/*{(node.name === "Virtualization" || node.elementType === "VIRTUALIZATION") && (
                  <li title={"Virtualization"} className="ico-add-block" style={{
                    backgroundColor: document.body.classList.contains("light") ?
                      "white" : "#2a2d36"}}>
                    <button className="ico ico-html-coding" onClick={e => virtualization(node, e)} />
                  </li>
                )}*/}
                {node.elementType !== "CONNECTION" &&
                  node.elementType !== "CRAWLER" &&
                  node.name !== "Reports" &&
                  node.elementType !== "REPORT" &&
                  node.name !== "Virtualization" &&
                  node.elementType !== "VIRTUALIZATION" &&
                  node.name !== "Runtime Variable" && (
                    <li
                      title={"Delete All"}
                      className="ico-add-block"
                      style={{
                        backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                      }}
                    >
                      <button className="ico ico-remove" data-action={"removeAll"} onClick={e => e.stopPropagation()} />
                    </li>
                  )}
                {node.elementType !== "CONNECTION" &&
                  node.name !== "Reports" &&
                  node.name !== "Virtualization" &&
                  node.elementType !== "VIRTUALIZATION" &&
                  node.elementType !== "REPORT" &&
                  node.name !== "Runtime Variable" && (
                    <li
                      title={"Add"}
                      className="ico-add-block"
                      style={{
                        backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                      }}
                    >
                      <button className="ico ico-add" data-action={"add"} onClick={e => e.stopPropagation()} />
                    </li>
                  )}
                {node.elementType !== "REPORT" && node.name !== "Runtime Variable" && (
                  <li
                    title={"Duplicate"}
                    className="ico-copy-block"
                    style={{
                      backgroundColor: document.body.classList.contains("light") ? "white" : "#2a2d36"
                    }}
                  >
                    <button className="fa fa-clone" data-action={"copy"} onClick={e => e.stopPropagation()} />
                  </li>
                )}
              </ul>
            )}
          </div>
          <div className={`${classes.tooltipTree}`}>
            {displayTooltip && tooltipText && <span className={`${classes.tooltipTreeText}`}>{tooltipText}</span>}
          </div>
        </React.Fragment>
      }
    </Draggable>
  );
};

// Create decorators object with our custom components
const decorators = {
  ...baseDecorators,
  Container: CustomContainer,
  Toggle: Toggle,
  Header: Header
};

export default decorators;
